import { render, staticRenderFns } from "./SingleDocument.vue?vue&type=template&id=fb641166&scoped=true&"
import script from "./SingleDocument.vue?vue&type=script&lang=js&"
export * from "./SingleDocument.vue?vue&type=script&lang=js&"
import style0 from "./SingleDocument.vue?vue&type=style&index=0&id=fb641166&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb641166",
  null
  
)

export default component.exports